import React from 'react'

const gatsbyDataContext = React.createContext()

function withGatsbyData(Component) {
  return function TemplateWrapper(props) {
    const {children: _, ...gatsbyData} = props
    return (
      <gatsbyDataContext.Provider value={gatsbyData}>
        <Component {...props} />
      </gatsbyDataContext.Provider>
    )
  }
}

function useGatsbyData() {
  return React.useContext(gatsbyDataContext)
}

export {withGatsbyData, useGatsbyData}
